import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import PageSubHeader from '../../components/common/page_sub_header'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import {PAGECOUNT} from '../../config/const'
import ReactPaginate from 'react-paginate'
import {rootStore} from '../../mobx/store'
import { customDateTimeFormat } from '../../helper/common'

const Notice = observer((props) => {
  const context = useContext(Page_settings)

  let [showList, setShowList] = useState([])
  let [pageCount, setPageCount] = useState(0)
  let [page, setPage] = useState(1)
  let [empty, setEmpty] = useState(false)

  const tbHeaders = [
    {
      name: strings.num,
      class: 'td-event-num',
    },
    {
      name: strings.title,
      class: 'td-event-title text-line ph-40 sm-ph-15',
      center: false
    },
    {
      name: strings.date,
      class: 'td-event-date',
    },
  ]

  useEffect(() => {
    getNotice(page)
  }, [page])

  const getNotice = (page) => {
    context.post( 'cs/notice_list', {no_cate: 1, page: page, count: PAGECOUNT},
      response => {
        setShowList(response.list)
        setPageCount(response.page_count)
        setEmpty(response.page_count == 0)
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const handlePageClick = (component) => {
    setPage(component.selected + 1)
  }

  const goDetail = (no_id) => {
    props.history.push(`/cs/notice_detail/${no_id}`);
  }

  return (
    <React.Fragment>
        <div className={'mt-30'}>
          <PageSubHeader pageName={strings.notice} pageMenu1={strings.main} pageMenu2={strings.cs_center} pageMenu={strings.notice}/>
         
          <TableHeader className={'mt-30 sm-none'} headers={tbHeaders}/>
                    <div className='event-container sm-mt-15 mb-40'>
                      {
                        showList.map((info, index) => {
                          return (
                            <div key={index} className='tb-row cursor-point tb-notice clickable-row-highlight' onClick={() => {goDetail(info.no_id)}}>
                              <TableCell
                                value={(page - 1) * PAGECOUNT + index + 1}
                                className={tbHeaders[0].class}
                                center={tbHeaders[0].center}
                                child={null}
                              />
                              <TableCell
                                value={info.no_title}
                                className={`${tbHeaders[1].class} hover-text-accent` }
                                center={tbHeaders[1].center}
                                child={null}
                              />
                              <TableCell
                                value={customDateTimeFormat(info.no_createdat)}
                                className={tbHeaders[2].class}
                                center={tbHeaders[2].center}
                                child={null}
                              />
                            </div>
                          )
                        })
                      }
                      {empty && <div className='d-center color-3a3335 fs-16 f-b empty_label hx-100'>{strings.empty_notice}</div>}
                    </div>
                    {pageCount > 1 &&
                    <ReactPaginate
                      previousLabel={''}
                      nextLabel={''}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={'pagination'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                    }
        </div>
    </React.Fragment>
  )
})

export default withRouter(Notice)


